export default {
  brand: "Sklepy",
  offers: "Okazje i Gazetki",
  products: "Produkty",
  showMoreOffers: "Zobacz wszystkie okazje i gazetki",
  showMoreProducts: "Zobacz wszystkie produkty",
  showMoreBrands: "Zobacz wszystkie sklepy"
}